export default __webpack_public_path__ + "static/media/hands.00fb3932.png";